(function () {
  var doc = document;
  if (!doc) return;

  function toArray(list) {
    return Array.prototype.slice.call(list || []);
  }

  function hydrateVideo(video) {
    if (!video || video.dataset.lazyLoaded === 'true') return;
    var sources = toArray(video.querySelectorAll('source[data-src]'));
    sources.forEach(function (source) {
      var src = source.getAttribute('data-src');
      if (!src) return;
      source.src = src;
      source.removeAttribute('data-src');
    });
    video.load();
    if (video.autoplay && typeof video.play === 'function') {
      var playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function () { });
      }
    }
    video.dataset.lazyLoaded = 'true';
  }

  var videos = toArray(doc.querySelectorAll('video[data-lazy]'));
  if (videos.length) {
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting && entry.intersectionRatio <= 0) return;
          var target = entry.target;
          observer.unobserve(target);
          hydrateVideo(target);
        });
      }, { rootMargin: '600px 0px' });
      videos.forEach(function (video) { observer.observe(video); });
    } else {
      videos.forEach(hydrateVideo);
    }
  }

  var images = toArray(doc.querySelectorAll('img:not([loading])'));
  images.forEach(function (img) {
    if (!img) return;
    if (img.dataset.lazyExclude === 'true') return;
    if (img.closest('[data-lazy-critical]')) return;
    if (img.closest('header') || img.closest('.hero')) return;
    img.setAttribute('loading', 'lazy');
  });
})();
